import { LoginRequest, UserControllerApi } from "@/services";
import { setPendingCatalogImports } from "@/utils/auth-storage";
import { useMutationWithLoading } from "@/utils/utils";

const getPendingImportTypes = (loginData: unknown): string[] => {
  if (typeof loginData !== "object" || loginData === null) return [];
  const { pendingMedicalCodesImport } = loginData as {
    pendingMedicalCodesImport?: unknown;
  };
  if (!Array.isArray(pendingMedicalCodesImport)) return [];
  return pendingMedicalCodesImport.filter(
    (type): type is string => typeof type === "string"
  );
};

/**
 * @author Shrinivas Mandhare
 */
export const useLogin = () =>
  useMutationWithLoading(
    async (params: LoginRequest & { xTENANTID?: string }) => {
      const response = await new UserControllerApi().getAccessToken1(
        params,
        params.xTENANTID
      );
      setPendingCatalogImports(getPendingImportTypes(response.data?.data));
      return response;
    }
  );
